<nz-modal
	[(nzVisible)]="showQRModal"
	(nzOnCancel)="handleCancel()"
	(nzOnOk)="handleOk()"
	nzWrapClassName="login-modal"
	nzWidth="600px"
	nzMaskClosable="false"
	nzKeyboard="false"
	nzCentered
>
	<ng-container *nzModalContent>
		<div class="content-holder qr-code">
			<img
				style=""
				src="../../../../assets/images/jobs-referral-hero-image.png"
				alt="QR Code"
				class="qr-code"
			/>
			<h2>Someone at Cloudstaff thinks you’re amazing and we agree.</h2>
			<p>
				Awesome! You’ve scanned a Cloudstaff “Magic Career Card” which not only
				will give you priority access to job oportunites, it means you are part
				of the the Cloudstaff Community.
			</p>
			<h3>By registering, you'll get:</h3>
			<ul>
				<li>
					<i class="fa-solid fa-circle-check"></i>Full access to job
					opportunities at Cloudstaff
				</li>
				<li>
					<i class="fa-solid fa-circle-check"></i>News, updates, and tips for
					your career
				</li>
				<li>
					<i class="fa-solid fa-circle-check"></i>Chances to win exclusive
					prizes and giveaways
				</li>
				<li>
					<i class="fa-solid fa-circle-check"></i>A head start you're already
					connected!
				</li>
			</ul>
			<p class="text-footer">
				We're proud to be the #1 place to work and we're always looking for
				standout people like you.
			</p>

			<button
				nz-button
				class="btn-next new-registration-btn"
				nzType="primary"
				nzSize="large"
				nzShape="round"
				style="margin:0px 10px 15px 0px"
				(click)="handleOk()"
			>
				Register now
			</button>

			<button
				nz-button
				class="btn-next new-registration-btn"
				nzType="default"
				nzSize="large"
				nzShape="round"
				(click)="handleCancel()"
			>
				I'll do it later
			</button>
		</div>
	</ng-container>
</nz-modal>
